/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

export const MANAGE_CONTRACTORS_MODEL = {
    id: null,
    waitTime: null,
    renewal: "",
    frequencyValue: "",
    timeUnit: null,
    leadDays: "",
    start: null,
    end: null,
    isValidOneTime: function () {
        return this.start != null && this.leadDays != null && this.leadDays !== "";
    },
    isValidCustom: function () {
        return this.frequencyValue != null && this.frequencyValue !== "" &&
            this.timeUnit != null  && this.start != null  && this.end != null &&
            this.leadDays != null && this.leadDays !== "";
    }
}
